import { render, staticRenderFns } from "./PortalApoioCadastro.vue?vue&type=template&id=042e8a16&"
import script from "./PortalApoioCadastro.vue?vue&type=script&lang=js&"
export * from "./PortalApoioCadastro.vue?vue&type=script&lang=js&"
import style0 from "./PortalApoioCadastro.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports